import { lazily } from 'react-lazily'
/**
 * Layouts
 */
import { SingleAction } from 'layout'
import Guard from 'guards/Guard'

const { RoleAdmin } = lazily(() => import('pages/home'))

const { ViewBousersList, EditBouser } = lazily(() => import('pages/bouser'))
const {
  AuditHome,
  AuditStudents,
  AuditProceedings,
  AuditBackofficeAccess,
  ViewBouserAuditList,
  ViewAccessAuditList,
  ViewStudentAuditList,
  ViewProceedingAuditList,
  AuditSettings,
  ViewSettingsAuditList,
  ViewLogEntryDetail,
} = lazily(() => import('pages/audit'))

const { AppSettings, ViewCryptoLimitsList, UploadAppBanner, ViewAppBanners } = lazily(() =>
  import('pages/app-settings')
)

const { UnbalanceAdmin, ViewUnbalancesList, FixUnbalance } = lazily(() => import('pages/unbalances'))

const { CBUAdmin, ViewAdminCbus, ViewFiletToBank, ImportCreatedCBUs } = lazily(() => import('pages/cbu'))

const { SGEAdmin, ViewSGEList } = lazily(() => import('pages/sge'))

const { FunctionAdmin, ViewFunctionList } = lazily(() => import('pages/manage-functions'))

/**
 * Layouts
 */
const LAYOUTS = {
  singleAction: SingleAction,
}

const basePath = '/dashboard/admin'

const adminRoutes = [
  {
    name: 'role-admin-home',
    path: basePath,
    element: RoleAdmin,
    guard: Guard,
    guardProps: { allowedRoles: ['Admin'] },
    suspenseFallback: null,
    childs: [
      {
        element: ViewBousersList,
        homeForRole: ['Admin'],
        name: 'admin-bouser-list',
        path: 'usuarios-backoffice',
        index: true,
        childs: [
          {
            name: 'admin-edit-bouser',
            path: ':id',
            layoutProps: { title: 'Datos del usuario/a', fullscreen: false },
            layout: LAYOUTS.singleAction,
            element: EditBouser,
          },
        ],
      },
    ],
  },
  {
    element: AppSettings,
    name: 'admin-app-settings',
    path: basePath + '/configuracion',
    childs: [
      {
        element: ViewCryptoLimitsList,
        name: 'admin-crypto-limits',
        path: 'limites-por-ciclo',
        index: true,
      },
      {
        element: ViewAppBanners,
        name: 'view-app-banners',
        path: 'banner-publicitario',
      },
      {
        element: UploadAppBanner,
        layout: LAYOUTS.singleAction,
        layoutProps: { title: 'Subir banner publicitario', parentRouteName: 'view-app-banners', },
        name: 'upload-app-banner',
        path: 'subir-banner',
      },
    ],
  },
  {
    element: UnbalanceAdmin,
    name: 'admin-unbalances',
    path: basePath + '/unbalances',
    guard: Guard,
    guardProps: { allowedRoles: ['Admin'] },
    suspenseFallback: null,
    childs: [
      {
        element: ViewUnbalancesList,
        homeForRole: ['Admin'],
        name: 'admin-unbalances',
        path: 'unbalances-list',
        index: true,
        childs: [
          {
            name: 'admin-fix-unbalance',
            path: ':id',
            layoutProps: { title: 'Datos del Desbalance', fullscreen: true },
            layout: LAYOUTS.singleAction,
            element: FixUnbalance,
          },
        ],
      },
    ],
  },
  {
    element: SGEAdmin,
    name: 'admin-sge',
    path: basePath + '/sge',
    guard: Guard,
    guardProps: { allowedRoles: ['Admin'] },
    suspenseFallback: null,
    childs: [
      {
        element: ViewSGEList,
        homeForRole: ['Admin'],
        name: 'admin-sge',
        path: 'sge-list',
        index: true,
        // childs: [
        //   {
        //     name: 'admin-fix-unbalance',
        //     path: ':id',
        //     layoutProps: { title: 'Datos del Desbalance', fullscreen: true },
        //     layout: LAYOUTS.singleAction,
        //     element: FixUnbalance,
        //   },
        // ],
      },
    ],
  }, {
    element: FunctionAdmin,
    name: 'admin-functions',
    path: basePath + '/functions',
    guard: Guard,
    guardProps: { allowedRoles: ['Admin'] },
    suspenseFallback: null,
    childs: [
      {
        element: ViewFunctionList,
        homeForRole: ['Admin'],
        name: 'admin-functions',
        path: 'function-list',
        // index: true,
        // childs: [
        //   {
        //     name: 'admin-fix-unbalance',
        //     path: ':id',
        //     layoutProps: { title: 'Datos del Desbalance', fullscreen: true },
        //     layout: LAYOUTS.singleAction,
        //     element: FixUnbalance,
        //   },
        // ],
      },
    ],
  },
  {
    element: CBUAdmin,
    name: 'admin-cbu',
    path: basePath + '/cbu',
    childs: [
      {
        element: ViewFiletToBank,
        name: 'admin-file-to-bank',
        path: 'admin-file-to-bank',
        index: true,
      },
      {
        element: ImportCreatedCBUs,
        name: 'import-cbu-accounts',
        path: 'import-cbu-accounts',
      },
      {
        element: ViewAdminCbus,
        name: 'admin-cbu-accounts',
        path: 'admin-cbu-accounts',
      },
      // {
      //   element: UploadFileToBank,
      //   layout: LAYOUTS.singleAction,
      //   layoutProps: { title: 'Subir Excle para procesar', parentRouteName: 'view-file-to-bank', },
      //   name: 'upload-bank-file',
      //   path: 'subir-file',
      // },
    ],
  },
  {
    name: 'admin-audit',
    path: basePath + '/auditoria',
    childs: [
      {
        element: AuditHome,
        name: 'admin-audit-users',
        path: 'usuarios',
        childs: [
          {
            element: ViewBouserAuditList,
            name: 'bouser-logs-list',
            path: 'usuarios-backoffice',
            index: true,
            childs: [
              {
                name: 'detalle-operacion',
                path: ':logid',
                layoutProps: { title: 'Detalle de operacion' },
                layout: LAYOUTS.singleAction,
                element: ViewLogEntryDetail,
              },
            ],
          },
        ],
      },
      {
        element: AuditBackofficeAccess,
        name: 'admin-audit-backoffice-access',
        path: 'acceso-backoffice',
        childs: [
          {
            element: ViewAccessAuditList,
            name: 'backoffice-access-logs-list',
            path: 'acceso-backoffice',
            index: true,
            childs: [
              {
                name: 'detalle-operacion',
                path: ':logid',
                layoutProps: { title: 'Detalle de operacion' },
                layout: LAYOUTS.singleAction,
                element: ViewLogEntryDetail,
              },
            ],
          },
        ],
      },
      {
        element: AuditStudents,
        name: 'admin-audit-students',
        path: 'alumnos',
        childs: [
          {
            element: ViewStudentAuditList,
            name: 'students-logs-list',
            path: 'estudiantes',
            index: true,
            childs: [
              {
                name: 'detalle-operacion',
                path: ':logid',
                layoutProps: { title: 'Detalle de operacion' },
                layout: LAYOUTS.singleAction,
                element: ViewLogEntryDetail,
              },
            ],
          },
        ],
      },
      {
        element: AuditProceedings,
        name: 'admin-audit-proceedings',
        path: 'expedientes',
        childs: [
          {
            element: ViewProceedingAuditList,
            name: 'proceedings-logs-list',
            path: 'expedientes',
            index: true,
            childs: [
              {
                name: 'detalle-operacion',
                path: ':logid',
                layoutProps: { title: 'Detalle de operacion' },
                layout: LAYOUTS.singleAction,
                element: ViewLogEntryDetail,
              },
            ],
          },
        ],
      },
      {
        element: AuditSettings,
        name: 'admin-audit-settings',
        path: 'configuracion',
        childs: [
          {
            element: ViewSettingsAuditList,
            name: 'settings-logs-list',
            path: 'configuracion',
            index: true,
            childs: [
              {
                name: 'detalle-operacion',
                path: ':logid',
                layoutProps: { title: 'Detalle de operacion' },
                layout: LAYOUTS.singleAction,
                element: ViewLogEntryDetail,
              },
            ],
          },
        ],
      },
    ],
  },
]

export default adminRoutes
